(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('draggable', draggable);

    /**
    * @ngdoc directive
    * @name swif.ui:draggable
    * @module swif.ui
    * @restrict EA
    * @description let this item being draggable using jqueryui
    **/
    function draggable() {
        var d = {};
        d.scope = {
            draggable: '&?'
        };
        d.link = function(scope, element) {
            if (scope.draggable()) {
                element.addClass('grab');
                element.draggable({
                    revert: true,
                    revertDuration: false,
                    start: function () {
                        element.find('.display-on-drag').toggle();
                        element.find('.hide-on-drag').toggle();
                    },
                    stop: function () {
                        element.find('.display-on-drag').toggle();
                        element.find('.hide-on-drag').toggle();
                    },
                    helper: 'clone',
                    appendTo: 'body',
                    containment: 'window',
                    scroll: false
                });
            }
        };
        return d;
    }

})();
